import IntercomRaw from "@intercom/messenger-js-sdk";

import type { IntercomType } from "./types";

export const Intercom = IntercomRaw as unknown as IntercomType;
